import React, {useCallback, useRef, useMemo} from 'react';
import {useDrag, useDrop} from 'react-dnd';
import {RangeSlider} from "@mantine/core";
import RichTextArea from "./Components/RichTextArea";

const itemType = 'row';
export const ProposalRow = ({
                                onDateRangeChange,
                                dateData,
                                selectedAllocationCoordinates,
                                setAllocationCoordinates,
                                lineItemId,
                                v,
                                selectedRoles,
                                getStaffRoleAllocationsForRole,
                                getHoursForRoleStaffFromLineItem,
                                onDescriptionChange,
                                onHoursChange,
                                handleDeleteLineItemButtonClick,
                                moveRow,
                                index,
                                id
                            }) => {
    var dragDirection = null;

    const ref = useRef(null);
    const [{handlerId, isActive}, drop] = useDrop({
        accept: itemType,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
                isActive: monitor.canDrop() && monitor.isOver(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            moveRow(dragIndex, hoverIndex, item.id);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        },

    });
    const [{isDragging}, drag, preview] = useDrag({
        type: itemType,
        item: () => {
            return {id, index};
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    preview(drop(ref));

    /*
   var dragDirection = null;
   // Determine rectangle on screen
   const hoverBoundingRect = ref.current?.getBoundingClientRect();
   if (hoverBoundingRect && currentDropItem) {
       const dragIndex = currentDropItem.index;
       const hoverIndex = index;

       // Get vertical middle
       const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
       // Get pixels to the top
       const hoverClientY = clientOffsetY - hoverBoundingRect.top;

       // Only perform the move when the mouse has crossed half of the items height
       // When dragging downwards, only move when the cursor is below 50%
       // When dragging upwards, only move when the cursor is above 50%
       // Dragging downwards
       if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
           dragDirection = 'down';
       }
       // Dragging upwards
       if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
           dragDirection = 'up';
       }
   }

   tdStyle = isActive && !isDragging && dragDirection == 'up' ? {borderTop: 'solid black 2px'} : tdStyle;
   tdStyle = isActive && !isDragging && dragDirection == 'down' ? {borderBottom: 'solid black 2px'} : tdStyle;*/

    var tdStyle = {};

    tdStyle = isDragging ? {backgroundColor: '#fefefe'} : tdStyle;

    const setInputFocus = (input) => {
        input.focus();
        setAllocationCoordinates(null);
    }
    return (
        <tr ref={ref} data-handler-id={handlerId}>
            <td style={tdStyle}>
                <div style={{display: 'flex', height: '100%'}}>
                    <a href="#" ref={drag}
                       style={{width: '15px', marginRight: '0.3em', backgroundColor: '#dfdfdf', float: 'left'}}></a>
                    <input type='text' value={v.name} required={true} style={{width:'0.3px', opacity: 0, padding:0, border:'none'}} />
                    <RichTextArea readOnly={window._disabled} style={useMemo(() => ({flexGrow: 2, backgroundColor: 'white', maxWidth: '40em'}), [])}
                              onChange={useCallback((text) => onDescriptionChange(lineItemId, text),[])} placeholder="Description"
                              value={v.name} name={lineItemId}/>
                </div>
                <div>
                    <TimeSlider
                                startDate={useMemo(() => dateData.startDate, [])}
                                endDate={useMemo(() => dateData.endDate,[])}
                                onDateRangeChange={useCallback(dateRange => onDateRangeChange(lineItemId, dateRange), [])}
                                // selectedStartDate={useMemo(() => v.startDate, [v.startDate])}
                                // selectedEndDate={useMemo(() => v.endDate, [v.startDate])}
                                selectedStartDate={v.startDate}
                                selectedEndDate={v.endDate}
                    />
                </div>
            </td>
            {selectedRoles.map((role, roleIndex) => {
                return (
                    getStaffRoleAllocationsForRole(role).map((staffRoleAllocation, sraIndex) => {
                        let className = sraIndex === (getStaffRoleAllocationsForRole(role).length - 1) ? 'role-border' : 'staff-border';
                        return (<td style={tdStyle} className={className}>
                            <input
                                style={{width: '100%'}} autoComplete="off" disabled={!staffRoleAllocation.id || window._disabled}
                                   ref={input => input &&
                                       (selectedAllocationCoordinates.y === index &&
                                           selectedAllocationCoordinates.roleIndex === roleIndex &&
                                           selectedAllocationCoordinates.sraIndex === sraIndex ?
                                               input.focus() || setAllocationCoordinates(null) : null
                                       )}
                                   onClick={(e) => setAllocationCoordinates(e, index, roleIndex, sraIndex)}
                                   onKeyDown={(e) => setAllocationCoordinates(e, index, roleIndex, sraIndex)}
                                   onChange={(e) => onHoursChange(lineItemId, staffRoleAllocation, e)}
                                   placeholder="Hours" type="text"
                                   value={getHoursForRoleStaffFromLineItem(v, staffRoleAllocation)}/>
                            {/*<div style={{height: '10px'}}>*/}
                            {/*    { getHoursForRoleStaffFromLineItem(v, staffRoleAllocation) ? <TimeSlider {...dateData} /> : null }*/}
                            {/*</div>*/}
                        </td>)
                    })
                )
            })}
            <td style={tdStyle}><a style={{backgroundColor: '#dfdfdf'}} href='#'

                                   onClick={window._disabled ? null : (e) => handleDeleteLineItemButtonClick(lineItemId, e)}
                                   className='js-delete_collection_entry'>x</a></td>
        </tr>);
};


const addBusinessDays = function (originalDate, numDaysToAdd) {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;

    const newDate = originalDate.clone();

    while (daysRemaining > 0) {
        newDate.add(1, 'days');
        if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
            daysRemaining--;
        }
    }

    return newDate;
}
const TimeSlider = React.memo(({
                        startDate,
                        endDate,
                        onDateRangeChange,
                        selectedStartDate = startDate,
                        selectedEndDate = endDate
                    }) => {

    const durationDays = endDate.diff(startDate, 'days');
    const marks = [];
    var selectedStartDateIndex = selectedStartDate.diff(startDate, 'days');
    var selectedEndDateIndex = selectedEndDate.diff(startDate, 'days');

    // const selectedStartDateIndex = Math.max(selectedStartDate.diff(startDate, 'days'), 0);
    // const selectedEndDateIndex = Math.min(selectedEndDate.diff(startDate, 'days'), durationDays);

    const Sunday = 0;
    const Saturday = 6;
    const newDate = startDate.clone();
    for (let i = 0; i < durationDays; i++) {
        newDate.add(1, 'days');
        if (newDate.day() === Sunday || newDate.day() === Saturday) {
            marks.push({value: i + 1});
        }
    }
    const labelStyles = {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        backgroundColor: '#333333',
        padding: '1px',
        borderRadius: '2px'
    };

    return (
        <RangeSlider
            marks={marks}
            styles={
                {
                    label: {
                        padding: '0',
                        borderRadius: '2px',
                        fontSize: '11px',
                        marginLeft: '0.5em',
                        backgroundColor: 'transparent',
                        top: 0
                    }
                }
            }
            onChange={v => onDateRangeChange([startDate.clone().add(v[0], 'days'), startDate.clone().add(v[1], 'days')])}
            value={[selectedStartDateIndex, selectedEndDateIndex]}
            color={"gray"}
            size={"xs"}
            min={0}
            max={durationDays}
            defaultValue={[0, durationDays]}
            step={1}
            minRange={1}
            label={(value) =>
                <div style={{...labelStyles, top: (value == selectedStartDateIndex ? '5px' : '-40px')}}>
                    <span>{startDate.clone().add(value, 'days').format('ddd')}</span>
                    <span>{startDate.clone().add(value, 'days').format('DD/MM')}</span>
                </div>
            }
            // label={value => addBusinessDays(startDate, value).format('ddd DD/MM')}
        />)
})
